"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefineObjectiveSubspace = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var RootReducer_1 = require("../app/RootReducer");
var Info_14px_small_1 = require("../img/Info_14px_small");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var SubspaceSlice_1 = require("../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var StateSelectors_1 = require("./StateSelectors");
var Index_1 = require("./base/Index");
var BinaryOutcomeDomainDropdown_1 = require("./objective-selection/BinaryOutcomeDomainDropdown");
var OutcomeDropdown_1 = require("./objective-selection/OutcomeDropdown");
var DefineObjectiveSubspace = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedObjective = (0, RootReducer_1.useAppSelector)(StateSelectors_1.objectiveSelector);
    var objectivesDefined = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelObjectivesDefined);
    var modelOutcomeList = (0, RootReducer_1.useAppSelector)(StateSelectors_1.modelOutcomeListSelector);
    var domainRetrievalStatus = (0, RootReducer_1.useAppSelector)(StateSelectors_1.domainRetrievalStatusSelector);
    var activeVersion = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelVersion);
    // TODO Quick workaround to reset the values on edit. This needs further work.
    React.useEffect(function () {
        if (activeVersion.objectiveTargetField &&
            modelOutcomeList &&
            modelOutcomeList.length > 0 &&
            selectedObjective &&
            (selectedObjective.outcomeField !== activeVersion.objectiveTargetField ||
                selectedObjective.algorithm !== activeVersion.objectiveAlgorithm ||
                selectedObjective.goal !== activeVersion.objectiveGoal)) {
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveTargetField, type: 'outcomeField' }));
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveGoal, type: 'goal' }));
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveAlgorithm, type: 'algorithm' }));
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveTargetFieldType, type: 'outcomeType' }));
        }
        if (activeVersion.objectiveTargetFieldType === Utils_1.OutcomeType.Text &&
            selectedObjective &&
            (selectedObjective.successValue !== activeVersion.objectiveSuccessValue ||
                selectedObjective.failureValue !== activeVersion.objectiveFailureValue)) {
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveSuccessValue, type: 'successValue' }));
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: activeVersion.objectiveFailureValue, type: 'failureValue' }));
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: [activeVersion.objectiveSuccessValue, activeVersion.objectiveFailureValue], type: 'domain' }));
        }
    }, [modelOutcomeList, activeVersion, dispatch, selectedObjective]);
    if (modelOutcomeList === undefined) {
        return React.createElement(Index_1.Loader, null);
    }
    var getGoalDropdownListItems = function () {
        var array = [];
        array.push({ value: Utils_1.Goal.Maximize });
        array.push({ value: Utils_1.Goal.Minimize });
        return array;
    };
    var getAlgorithmDropdownListItems = function () {
        var array = [];
        array.push({ value: Utils_1.Algorithm.GBM, content: Localize_1.Messages.GBMLabel() });
        array.push({ value: Utils_1.Algorithm.GLM, content: Localize_1.Messages.GLMLabel() + Localize_1.Messages.recommendSuffix() });
        array.push({ value: Utils_1.Algorithm.Model_Tournament, content: Localize_1.Messages.ModelTournamentLabel() });
        array.push({ value: Utils_1.Algorithm.RandomForest, content: Localize_1.Messages.RandomForestLabel() });
        array.push({ value: Utils_1.Algorithm.XGBoost, content: Localize_1.Messages.XGBoostLabel() });
        return array;
    };
    var handleChangeCallback = function (value, type) {
        switch (type) {
            case 'goal':
                dispatch((0, SubspaceSlice_1.updateObjective)({ value: value, type: type }));
                dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveGoal: value }));
                break;
            case 'algorithm':
                dispatch((0, SubspaceSlice_1.updateObjective)({ value: value, type: type }));
                dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveAlgorithm: value }));
                break;
        }
    };
    var getFieldTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.fieldTooltip()); };
    var getGoalTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.goalTooltip()); };
    var getAlgorithmTooltipContent = function () { return React.createElement("span", null, Localize_1.Messages.algorithmTooltip()); };
    var goal = selectedObjective.goal;
    var algorithm = selectedObjective.algorithm;
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#ffffff',
        } },
        React.createElement("div", { style: {
                width: '30%',
                height: '90%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ffffff',
            } },
            React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                React.createElement("label", null, Localize_1.Messages.chooseTargetTitle())),
            React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                React.createElement("label", null, Localize_1.Messages.chooseTargetDescription())),
            React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                React.createElement(OutcomeDropdown_1.OutcomeDropdown, { outcomes: modelOutcomeList }),
                React.createElement("div", { hidden: domainRetrievalStatus !== Utils_1.DomainRetrievalStatus.Retrieving, style: { backgroundColor: 'white', height: '15px', zIndex: 0, marginTop: '35px', marginLeft: '-17px' } },
                    React.createElement(widgets_1.ActivitySpinnerWidget, { spinnerSize: widgets_1.ActivitySpinnerSize.Small, testId: TestIds_1.BINARY_DOMAIN_DROPDOWN_SPINNER_TEST_ID, shouldShowUnderlay: false })),
                React.createElement("div", { style: { marginTop: '10px' } },
                    React.createElement(widgets_1.Tooltip, { getContent: getFieldTooltipContent },
                        React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))),
                    ' ')),
            React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                    React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.GOAL_DROPDOWN_LIST_TEST_ID, label: Localize_1.Messages.goalListTitle(), list: React.createElement(widgets_1.List, { items: getGoalDropdownListItems(), selectedValue: goal }), onChange: function (field) {
                            handleChangeCallback(field, 'goal');
                        }, type: widgets_1.DropdownButtonType.Outline, disabled: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Retrieving, value: selectedObjective.goal })),
                React.createElement("div", { style: { marginTop: '10px' } },
                    React.createElement(widgets_1.Tooltip, { getContent: getGoalTooltipContent },
                        React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))))),
            selectedObjective.outcomeType === Utils_1.OutcomeType.Text && selectedObjective.domain && selectedObjective.domain.length === 2 && (React.createElement("div", { style: { width: '87%', alignItems: 'left', display: 'flex' } },
                React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                    React.createElement(BinaryOutcomeDomainDropdown_1.BinaryOutcomeDomainDropdown, null)))),
            React.createElement("div", { style: { width: '90%', alignItems: 'left', display: 'flex' } },
                React.createElement("div", { style: { width: '100%', marginTop: '10px' } },
                    React.createElement(widgets_1.SingleSelectDropdown, { testId: TestIds_1.ALGORITHM_DROPDOWN_LIST_TEST_ID, label: Localize_1.Messages.modelAlgorithmTitle(), list: React.createElement(widgets_1.List, { items: getAlgorithmDropdownListItems(), selectedValue: algorithm }), onChange: function (field) {
                            handleChangeCallback(field, 'algorithm');
                        }, type: widgets_1.DropdownButtonType.Outline, disabled: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Retrieving, value: selectedObjective.algorithm })),
                React.createElement("div", { style: { marginTop: '10px' } },
                    React.createElement(widgets_1.Tooltip, { getContent: getAlgorithmTooltipContent },
                        React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))),
                    ' ')),
            React.createElement("div", { style: {
                    width: '100%',
                    borderTopWidth: 2,
                    borderTopStyle: 'solid',
                    borderTopColor: '#605C5C',
                    height: 0,
                    marginTop: '50px',
                } }),
            React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', textAlign: 'left', wordBreak: 'break-word' } },
                React.createElement("label", null, Localize_1.Messages.forNextStepDescription())),
            React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                React.createElement(widgets_1.ButtonWidget, { testId: TestIds_1.CHOOSE_TARGET_NEXT_STEP_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary, disabled: !objectivesDefined, onClick: function () { return dispatch((0, SubspaceSlice_1.setSubspace)(Utils_1.SubspaceType.Train)); } }, Localize_1.Messages.nextStepButton())))));
};
exports.DefineObjectiveSubspace = DefineObjectiveSubspace;
//# sourceMappingURL=DefineObjectiveSubspace.js.map